import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive'
import RoomServiceIcon from '@mui/icons-material/RoomService'
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation'
import TrainIcon from '@mui/icons-material/Train'
import HailIcon from '@mui/icons-material/Hail'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'
import { Category } from '@mui/icons-material'
import RouteIcon from '@mui/icons-material/Route'

export const ProductIconst = {
  air_detail: <AirplanemodeActiveIcon />,
  car_detail: <DirectionsCarIcon />,
  hotel_detail: <RoomServiceIcon />,
  attendance: <MedicalInformationIcon />,
  train_detail: <TrainIcon />,
  train: <TrainIcon />,
  train_detail_passes: <TrainIcon />,
  transfer_detail: <HailIcon />,
  assistance_detail: <MedicalServicesIcon />,
  other_detail: <Category />,
  train_detail_segment: <RouteIcon />,
}

export const Product = {
  air_detail: 'air_detail',
  car_detail: 'car_detail',
  hotel_detail: 'hotel_detail',
  attendance: 'attendance',
  train_detail: 'train_detail',
  assistance_detail: 'assistance_detail',
}

export const ProductTabbedView = {
  passangger: '1',
  air_detail: '2',
  hotel_detail: '3',
  car_detail: '4',
  train_detail: '5',
}
